BaseLayer = require './base-layer'
DraggabilityMixin = require 'mixins/map-draggability'
PopupMixin = require 'mixins/map-popup'
toLatLng = require 'computeds/to-lat-lng'

module.exports = App.MarkerLayerComponent = BaseLayer.extend DraggabilityMixin, PopupMixin,
  leafletRequiredOptions: [ 'location' ]
  leafletOptions: [
    'icon'
    'clickable'
    'draggable'
    'keyboard'
    'title'
    'alt'
    'zIndexOffset'
    'opacity'
    'riseOnHover'
    'riseOffset'
  ]
  leafletEvents: [
    'click'
    'dblclick'
    'mousedown'
    'mouseover'
    'mouseout'
    'contextmenu'
    'dragstart'
    'drag'
    'dragend'
    'move'
    'remove'
    'popupopen'
    'popupclose'
  ]
  leafletProperties: [
    'icon'
    'zIndexOffset'
    'opacity'
    'location:setLatLng'
  ]
  location: toLatLng()
  createLayer: ->
    @L.marker.apply @L, @get('requiredOptions').concat([ @get('options') ])
